import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getFabricType,
  addFabricType,
  deleteFabricType,
  updateFabricType,
} from "../../redux/actions/FabricType.action";

import { getLog } from "../../redux/actions/log.action";
import { getRights } from "../../redux/actions/userRights.action";

import PageHeader from "../../components/PageHeader/PageHeader";
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { ReadCookie } from "../../utils/readCookie";
import Tables from "../../components/Table/Tables";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Divider } from "antd";

import { logColumns, fabricTypeColumns } from "../../utils/cols";
import notification from "../../utils/notification";
import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";
const { TabPane } = Tabs;
export default function FabricType({ token }) {
  TabTitle("Fabric Type")
  const menuId = ReadCookie("menuId");

  const FabricTypeNameInput = useRef(null);
  const [form] = Form.useForm();
  const [fabricTypeObj, setFabricTypeObj] = useState(null);
  const dispatch = useDispatch();
  const { fabricType, log, userRights } = useSelector((state) => state);
  const [minimize, setMinimize] = useState(false);
  const [check, setCheck] = useState(false);
  const [fabricTypeName, setFabricTypeName] = useState("");
  const [disable, setDisable] = useState(false);
  const [formState, setFormState] = useState("view");

  useEffect(() => {
    dispatch(getFabricType(token, menuId));
    // dispatch(getLog(token));
    dispatch(getLog(token, { inv_fabric_type: "inv_fabric_type" }))
  }, [token]);

  useLayoutEffect(() => {
    dispatch(getRights(token, menuId)).then((res) => {
      if (res.type === "GET_USER_RIGHTS_SUCCESS") {
        if (!res?.payload.can_add) {
          setFormState("table");
        }
      }
    });
  }, []);

  useEffect(() => {
    if (fabricTypeObj) {
      setFormState("view");
      form.setFieldsValue({
        id: fabricTypeObj.fabric_type_id,
        fabricType: fabricTypeObj.fabric_type_name,
        active: fabricTypeObj.is_active,
      });
      setFabricTypeName(fabricTypeObj.fabric_type_name);
      setCheck(fabricTypeObj.is_active);
    }
  }, [fabricTypeObj]);

  useEffect(() => {
    if (fabricTypeName === "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [fabricTypeName]);

  const handleTab = (key) => {
    if (key === "logs") {
      dispatch(
        getLog(token, {
          inv_fabric_type: "inv_fabric_type",
          admin_company_entity_access: "admin_company_entity_access",
        })
      );
    }
  };

  const formSave = () => {
    if (formState === "add") {
      dispatch(addFabricType(token, { fabricTypeName, check }, menuId)).then(
        (res) => {
          if (res.type === "ADD_FABRICTYPE_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          if (res.type === "ADD_FABRICTYPE_SUCCESS") {
            notification(
              "success",
              "Fabric Type Created",
              "Record updated successfully"
            );
            form.setFieldsValue({
              fabricType: ""
          })
          setFormState("")
          // setCheck(false)
          setFabricTypeName("")
          setFabricTypeObj(null)
          }
          dispatch(getFabricType(token));
        }
      );
    }

    if (formState === "edit") {
      dispatch(
        updateFabricType(
          token,
          { fabricTypeName, check },
          fabricTypeObj.fabric_type_id
        )
      ).then((res) => {
        if (res.type === "UPDATE_FABRICTYPE_ERROR") {
          notification("error", "Update", "Something went wrong");
        }
        if (res.type === "UPDATE_FABRICTYPE_SUCCESS") {
          notification(
            "success",
            "Fabric Type Updated",
            "Record updated successfully"
          );
        }
        dispatch(getFabricType(token));
      });
    }
  };

  const handleDelete = () => {
    if (fabricTypeObj) {
      dispatch(deleteFabricType(token, fabricTypeObj.fabric_type_id)).then(
        (res) => {
          if (res.type === "DELETE_FABRICTYPE_SUCCESS") {
            notification(
              "success",
              "Fabric Type Deleted",
              "Fabric Type deleted successfully!"
            );
          }
          if (res.type === "DELETE_FABRICTYPE_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          form.setFieldsValue({
            fabricType: "",
          });
          // setCheck(false)
          setFabricTypeName("");
          setFabricTypeObj(null);
          setFormState("");
          dispatch(getFabricType(token));
        }
      );
    }
  };

  useEffect(() => {
    if (formState === "add") {
       
        FabricTypeNameInput.current.focus();
        form.setFieldsValue({
            fabricType: ""
        })
        setCheck(true)
        setFabricTypeName("")
        setFabricTypeObj(null)
    }
}, [formState]);

  const filterReset = () => {
    setFormState("view");
  };

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Fabric Type"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="crudDiv">
              <CrudButtons
                rights={userRights?.payload}
                reset={filterReset}
                formType={formState}
                save={formSave}
                disable={disable}
                formState={setFormState}
                onDelete={handleDelete}
              />
            </div>

            <div className="styleContent">
              <Row className="tables-main-row-new">
                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                  <div className="styleTable">
                    <Tables
                      type="fabricType"
                      fabricTypeObj={setFabricTypeObj}
                      scrollX={"20rem"}
                      scroll={602}
                      perPage={25}
                      source={fabricType?.payload?.data}
                      col={fabricTypeColumns}
                      paginate
                      load={fabricType.loading}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                  <div className="styleForm">
                    <Form form={form} name="basic" labelCol={{ span: 8 }}>
                      <div className="customRow styleFormUpper ">
                        {fabricTypeObj !== null && !(formState === "add") && (
                          <div className="customCols slc">
                            <Form.Item
                              label="ID"
                              name="id"
                              initialValue={form.getFieldValue().id}
                              labelCol={{ span: 10 }}
                              wrapperCol={{ span: 14 }}
                            >
                              <Input
                                size="small"
                                className="styleInput id-field-style"
                                readOnly
                              />
                            </Form.Item>
                          </div>
                        )}
                        <div className="customCols slc">
                          <Form.Item
                            label="Fabric Type"
                            name="fabricType"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            initialValue={form.getFieldValue().style}
                          >
                            <Input
                              size="small"
                              // placeholder="Fabric Type Name"
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              ref={FabricTypeNameInput}
                              onChange={(e) =>
                                setFabricTypeName(e.target.value)
                              }
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                        <div className="customCols slc">
                          <Form.Item
                            label="Active"
                            name="active"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <Checkbox
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              checked={check}
                              onChange={(e) => setCheck(e.target.checked)}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Form>
                    <Divider />
                    <div className="styleTab">
                      <Tabs
                        type="card"
                        tabBarGutter={2}
                        defaultActiveKey="1"
                        centered
                        onChange={(key) => handleTab(key)}
                      >
                        <TabPane tab="Log Info" key="logs">
                          <div className="tabs">
                            <Tables
                              type="company"
                              scrollX={"50rem"}
                              scroll={360}
                              perPage={15}
                              source={log?.payload?.data}
                              col={logColumns}
                              load={log.loading}
                              paginate
                            />
                          </div>
                        </TabPane>
                      </Tabs>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
      {minimize && (
        <div className="styleFooter">
          <Button
            className="minimize-button-style"
            onClick={() => setMinimize(false)}
          >
            Style
          </Button>
        </div>
      )}
    </div>
  );
}
